import { Component, DestroyRef, inject, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { ApiService } from "@core/services/api.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AppConstants } from "@core/constants";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { DeactivationAthleteInterface } from "@shared/interfaces/deactivation-athlete.interface";

@Component({
  selector: 'app-deactivate-athlete-dialog',
  templateUrl: './deactivate-athlete-dialog.component.html',
  styleUrls: ['./deactivate-athlete-dialog.component.scss']
})
export class DeactivateAthleteDialogComponent {
  private apiService: ApiService = inject(ApiService);
  private snackBar: MatSnackBar = inject(MatSnackBar);

  public title: string;
  public message: string;
  public athlete: any;
  public isDeactivate: boolean = false;
  public isScheduledDeactivate: boolean = false;
  public destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    public dialogRef: MatDialogRef<DeactivateAthleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeactivationAthleteInterface,
  ) {
    this.title = data.title;
    this.message = data.message;
    this.athlete = data.athlete;
    this.isDeactivate = this.athlete.is_active && !this.athlete.is_deactivation_scheduled;
    this.isScheduledDeactivate = this.athlete.is_active && this.athlete.is_deactivation_scheduled;
  }

  public onDeactivate(): void {
    this.apiService.post('deactivate_url', { athlete_id: this.athlete.id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: (err: any) => {
          this.dialogRef.close(false);
          this.snackBar.open('Error has happened', 'OK', AppConstants.TOAST_CONFIG.ERROR);
        }
      });
  }

  public onScheduledDeactivate(): void {
    this.apiService.post('scheduled_deactivate_url', { athlete_id: this.data.athlete.id })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {
          this.dialogRef.close(true);
        },
        error: (err: any) => {
          this.dialogRef.close(false);
          this.snackBar.open('Error has happened', 'OK', AppConstants.TOAST_CONFIG.ERROR);
        }
      });
  }

  public onDismiss(): void {
    this.dialogRef.close(false);
  }
}
